export default __webpack_public_path__ + "static/media/cert-E-commerce-cpttm.c5ef7f9f.jpg";